
      import { datadogRum } from '@datadog/browser-rum';
      import userMessages from '/src/constants/userMessages';

      datadogRum.init({
        applicationId: "61afa1a4-c7f9-459e-9800-05b835a0ea0c",
        clientToken: "pub4fabc9893e3a6dae45f10b153c832a81",
        site: 'datadoghq.com',
        service: "acv-web-vuejs",
        env: "latest",
        version: "68df2e0c58e436e4aea24f5fedde54845be725e6", 
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        startSessionReplayRecordingManually: true,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        allowedTracingUrls: [ /https:\/\/(?!(ent-micro-pricing|acv-api-|inventory-onboarding|acv-static-assets)).*\.acvauctions\.com/],
        excludedActivityUrls: [        
          /https:\/\/.*\.nr-data\.net/,
          /https:\/\/.*\.hotjar\.com/,
          /https:\/\/.*\.salesforceliveagent\.com/,
          /https:\/\/.*\.service\.force\.com/,
          /https:\/\/.*\.pndsn\.com/,
          /https:\/\/.*\.linkedin\.com/,
          /https:\/\/google-analytics\.com/,
          /https:\/\/facebook\.com/,
          /https:\/\/.*\.mixpanel\.com/,
        ],
        beforeSend: (event, context) => {
          // discard a RUM error for cancelled fetches
          if (event.type === 'error' 
              && (event.error.message.includes('CanceledError')
                || event.error.message.includes(userMessages.errors.canceledFetch))) {
              return false
          }
        },
      });
    